import { useCallback, useMemo, useState } from "react";
import { seasonFor } from "../data/seasons";
import { useSeasonSettings } from "../context/SeasonContext";

const DISMISS_KEY = "gatherly_season_dismissed";

const readDismissed = () => {
  try {
    return localStorage.getItem(DISMISS_KEY);
  } catch {
    return null;
  }
};

// The seasonal theme to show now, from the settings the API provides
// (see context/SeasonContext.js) and today's date.
export default function useSeason() {
  const settings = useSeasonSettings();
  const [dismissed, setDismissed] = useState(readDismissed);

  const season = useMemo(() => seasonFor(new Date(), settings), [settings]);

  // A banner closed for one theme comes back when the next theme starts.
  const dismiss = useCallback(() => {
    if (!season) return;
    try {
      localStorage.setItem(DISMISS_KEY, season.id);
    } catch {
      // ignore storage failures
    }
    setDismissed(season.id);
  }, [season]);

  return {
    season,
    showBanner: Boolean(season) && settings.banner && dismissed !== season?.id,
    showEffects: Boolean(season) && settings.effects,
    showAmbient: Boolean(season) && settings.effects && settings.ambient,
    ambientDensity: settings.ambientDensity,
    stickyBanner: settings.stickyBanner,
    headerAccent: Boolean(season) && settings.headerAccent,
    dismiss: settings.dismissible ? dismiss : null,
  };
}
